/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AncillaryDistributionListConfiguration,
    AncillaryDistributionListConfigurationFromJSON,
    AncillaryDistributionListConfigurationToJSON,
    AncillaryDistributionListItem,
    AncillaryDistributionListItemFromJSON,
    AncillaryDistributionListItemToJSON,
    AncillaryDistributionListQuery,
    AncillaryDistributionListQueryFromJSON,
    AncillaryDistributionListQueryToJSON,
} from '../models';

export interface ApiAncillaryDistributionListDataPostRequest {
    ancillaryDistributionListQuery?: AncillaryDistributionListQuery;
}

/**
 * no description
 */
export class AncillaryDistributionListApi extends runtime.BaseAPI {

    /**
     */
    async apiAncillaryDistributionListConfigurationGetRaw(): Promise<runtime.ApiResponse<AncillaryDistributionListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryDistributionList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillaryDistributionListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillaryDistributionListConfigurationGet(): Promise<AncillaryDistributionListConfiguration> {
        const response = await this.apiAncillaryDistributionListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiAncillaryDistributionListDataPostRaw(requestParameters: ApiAncillaryDistributionListDataPostRequest): Promise<runtime.ApiResponse<Array<AncillaryDistributionListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryDistributionList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillaryDistributionListQueryToJSON(requestParameters.ancillaryDistributionListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AncillaryDistributionListItemFromJSON));
    }

    /**
     */
    async apiAncillaryDistributionListDataPost(requestParameters: ApiAncillaryDistributionListDataPostRequest): Promise<Array<AncillaryDistributionListItem>> {
        const response = await this.apiAncillaryDistributionListDataPostRaw(requestParameters);
        return await response.value();
    }

}
